import CSVUploadModel from '../CSVUpload/model/CSVUploadModel';

const CSVUploadStore = {
    name: 'CSVUploadStore',
    spec: CSVUploadModel,
    saveLocally: false,
    initialState: {
        res:"Oops...Something went wrong. Please try again."
    }
}

const stores=[CSVUploadStore]

export default stores;